export default __webpack_public_path__ + "static/media/youtube.b11d7e71.svg";